<template>
  <div class="headerPage">
    <!-- 页面顶部导航组件 -->
    <div class="header">
      <div class="headerDiv">
        <div class="header-logo">
          <router-link to="/">
            <img src="../header/img/logo.png" />
            <span @click="printREFS()">
              <em>U学</em>商情 <em v-show="showBate">Beta</em>
            </span>
            <em style="color:red;margin-left: 20px;" v-show="showBate"
              >测试数据仅限通信行业，时间为2019.01.01至2019.10.31。</em
            >
          </router-link>
        </div>
        <div class="header-nav">
          <el-menu
            theme="dark"
            :default-active="isHeaderActiveIndex"
            class="el-menu-demo"
            mode="horizontal"
            :router="false"
            :key="menukey"
          >
          <el-menu-item @click="popActivity.show = true">
            <img style="height: 50px;" src="../../common/img/ux_head.png"/>
          </el-menu-item>
            <el-menu-item index="1" @click="goIndex()">首页</el-menu-item>
            <!-- <el-menu-item index="2" disabled>订阅服务</el-menu-item> -->

            <el-menu-item index="2" @click="goSearch()">标讯搜索</el-menu-item>
            <!-- <el-submenu index="2">
              <template slot="title"
                >订阅服务</template
              >
              <el-menu-item index="2-1" @click="goSubscription(0)"
                >关键词订阅</el-menu-item
              >
              <el-menu-item index="2-2" @click="goSubscription(1)"
                >资质订阅</el-menu-item
              >
              <el-menu-item index="2-3" @click="goBusinessSubscription()"
                >分类订阅</el-menu-item
              >
            </el-submenu> -->

            <el-menu-item index="3" v-on:click="goCompanyAnalyze()"
              >企业分析<!-- <img class="bxfxImg" src="./img/beta.png"> --></el-menu-item
            >
            <el-menu-item index="4" v-on:click="goTenderAnalyze()"
              >标讯分析<!-- <img class="bxfxImg" src="./img/beta.png"> --></el-menu-item
            >
            <el-menu-item index="5" v-on:click="goDataExport()"
              >数据导出</el-menu-item
            >
            <!-- <el-menu-item index="5">数据导出</el-menu-item> -->
          </el-menu>
        </div>
        <a
          href="javascript:;"
          class="header-loginBtn"
          v-show="loginBtnShow"
          @click="login"
          >登录</a
        >
        <div class="header-me" v-show="meShow">
          <!-- @click="memeListShow" -->
          <div id="userMsg" :class="userMsgStyle">
            <span class="userAvatar">
              <img :src="userAvatarLink" />
            </span>
            <div class="meMsg">
              <div class="userName">{{ userName }}</div>
              <div class="userPhone">{{ userPhone }}</div>
            </div>

            <i>
              <img src="../header/img/meMoreIco.png" />
            </i>
          </div>
          <div class="meList" :id="meListStyle">
            <a href="javascript:;" class="a01" @click="isVipMember()"
              >VIP会员</a
            >
            <!-- <a href="javascript:;" class="a02">关注项目</a>-->
            <!-- <a href="javascript:;" class="a03">关注领域</a> -->
            <a href="javascript:;" class="a04" @click="goOrder">我的订单</a>
            <a href="javascript:;" class="a05" @click="goExportRecord"
              >导出记录</a
            >
            <a href="javascript:;" class="a08" @click="goAttentionProject"
              >关注项目</a
            >
            <a href="javascript:;" class="a09" @click="goAttentionCompany"
              >关注企业</a
            >
            <a href="javascript:;" class="a06" @click="goFindPassword"
              >重置密码</a
            >
            <a href="javascript:;" class="a07" @click="exitLogin">退出登录</a>
          </div>
        </div>
      </div>
    </div>

    <!-- 引入会员购买组件-start -->
    <vipBuyWindow ref="vipBuyWindowPart"></vipBuyWindow>
    <!-- 引入会员购买组件-end -->

    <!-- 引入二维码登录组件-start -->
    <ewmLogin :isLogin="isLogin" ref="ewmLogin"></ewmLogin>
    <!-- 引入二维码登录组件-end -->

    <!-- 引入手机登录组件-start -->
    <phoneLogin ref="phoneLoginPart"></phoneLogin>
    <!-- 引入手机登录组件-end -->

    <!-- 引入U讯广告活动组件 -->
    <pop-activity :value.sync="popActivity.show"></pop-activity>
    <div v-show="popActivity.showRigth" style="position: fixed;top: 50vh;right: 0;z-index: 100;cursor: pointer;">
      <div @click="popActivityRigthClose"><i class="el-icon-close"></i></div>
      <div @click="popActivity.show = true"><img style="width: 7vw;" src="../../common/img/ux_right.png"/></div>
    </div>
    <!-- 引入U讯广告活动组件end -->
  </div>
</template>

<script>
import { getVersion } from "@/api/requestUrl"; //公共js
import vipBuyWindow from "@/page/vipMember/vipBuy.vue"; //会员购买组件
import ewmLogin from "@/components/ewmLogin/ewmLogin.vue"; //二维码登录组件
import phoneLogin from "@/components/phoneLogin/phoneLogin.vue"; //手机登录组件
import popActivity from "@/components/popActivity/popActivity.vue";
import { base } from '@/common/js/base.js';
export default {
  name: "headerPage",
  components: {
    vipBuyWindow, //会员购买组件
    ewmLogin, //二维码登录组件
    phoneLogin, //手机登录组件
    popActivity
  },
  data() {
    return {
      isHeaderActiveIndex: this.headerActiveIndex,
      userMsgStyle: "",
      meListStyle: "",
      meShow: false,
      loginBtnShow: false,
      userAvatarLink: "", //用户的头像链接
      userName: "", //用户昵称
      userPhone: "", //用户绑定的手机号码
      // isVipTypeSelectShow:false,
      merberStatus: "", //会员状态
      isLogin: false, //是否要二维码登录
      tenderDetail: false,
      showBate: false,
      pcVipStatus: false, //true:为pc端会员；false：非pc端会员(不包含移动端月会员)
      isPcVipTips: "该功能只对年会员和企业会员开放",
      isMemberVipStatus: false, //true:为vip会员；false：非vip会员(包含移动端月会员)
      bgShow: false,
      popActivity:{
        show:false,
        showRigth:true,
      },
      menukey:1
    };
  },
  props: ["headerActiveIndex"],
  methods: {
    popActivityRigthClose(){
      this.popActivity.showRigth = false;
      localStorage.setItem("popActivity.showRigth",base().formatDate(Date.now()));
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },

    //跳转到导出记录
    goExportRecord: function() {
      var that = this;
      that.$router.push({
        path: "/exportRecord" //跳转的路由
      });
    },

    //跳转到首页
    goIndex: function() {
      var that = this;
      that.$router.push({
        path: "/index" //跳转的路由
      });
    },
    //跳转到搜索
    goSearch: function() {
      var that = this;
      that.$router.push({
        path: "/tender/search" //跳转的路由
      });
    },

    //判断是否绑定手机
    isBindPhone: function() {
      var that = this;
      that.requestApi({
        method: "get",
        url: "/api/user/isBindingPhone",
        data: {},
        then(data) {
          console.log("data:" + data.data);
          //未绑定手机号码
          if (data.data == false) {
            that.$refs.phoneLoginPart.openBindPhone(); //弹出绑定手机
          }
        }
      });
    },

    //跳转到业务订阅
    goBusinessSubscription: function() {
      var that = this;
      that.$router.push({
        path: "/businessSubscription" //跳转的路由
      });
    },

    //跳转到关注项目
    goAttentionProject: function() {
      var that = this;
      that.$router.push({
        path: "/attentionProject" //跳转的路由
      });
    },

    //跳转到关注企业
    goAttentionCompany: function() {
      var that = this;
      that.$router.push({
        path: "/attentionCompany" //跳转的路由
      });
    },

    // 跳转标讯分析页面
    goTenderAnalyze: function() {
      var that = this;
      if (that.isLogin == true) {
        var ewmLogin = that.$refs.ewmLogin;
        if (ewmLogin != null) {
          ewmLogin.showLogin();
        }
        return false;
      }
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
      var startTime = that.$moment(start).format("YYYY-MM-DD");
      var endTime = that.$moment(end).format("YYYY-MM-DD");
      var param = {
        startTime: startTime,
        endTime: endTime,
        guildId: 1,
        businessTypeArray: []
      };
      if (that.pcVipStatus == true) {
        that.$router.push({
          path: "/analyzeNew", //跳转的路由
          query: param //参数对象
        });
      } else {
        this.menukey++
        console.log("跳转标讯分析页面that.pcVipStatus:" + that.pcVipStatus);
        that.isPcVipTips =
          "查看运营商、电力、政企行业、业务、区域、规模等多维度市场分析，可开通钻石会员、年会员或企业会员";
        if (that.bgShow == true) {
          that.$refs.vipBuyWindowPart.openTenderAnalyzeBg(); //打开标讯分析背景图
        }
        that.getMerberStatus({
          successFn: function() {
            that.$router.push({
              path: "/analyzeNew", //跳转的路由
              query: param //参数对象
            });
          }
        });
      }
    },

    /**
     * 跳转企业分析页面
     */
    goCompanyAnalyze: function() {
      var that = this;
      console.log(that);
      if (that.isLogin == true) {
        var ewmLogin = that.$refs.ewmLogin;
        if (ewmLogin != null) {
          ewmLogin.showLogin();
        }
        return false;
      }
      if (that.pcVipStatus == true) {
        that.$router.push({
          path: "/analysisSearch", //跳转的路由
          query: "" //参数对象
        });
      } else {
        this.menukey++
        console.log("跳转企业分析页面that.pcVipStatus:" + that.pcVipStatus);
        that.isPcVipTips =
          "查看企业最新中标动态、业务拓展版图、历年中标项目等，可开通钻石会员、年会员或企业会员";
        if (that.bgShow == true) {
          that.$refs.vipBuyWindowPart.openCompanyAnalyzeBg(); //打开企业分析背景图
        }

        // if (that.pcVipStatus != "") {

        // } else {
        //   that.$refs.vipBuyWindowPart.closeCompanyAnalyzeBg(); //关闭企业分析背景图
        // }
        that.getMerberStatus({
          successFn: function() {
            that.$router.push({
              path: "/analysisSearch", //跳转的路由
              query: "" //参数对象
            });
          }
        });
      }
    },

    goDataExport: function() {
      var that = this;
      that.$router.push({
        path: "/conditionFilter", //跳转的路由
        query: "" //参数对象
      });
    },

    //标讯列表跳转-携带id
    goSubscription(subscribeType) {
      var that = this;
      var subscribeType = subscribeType;
      that.$router.push({
        path: "/subscription", //跳转的路由-订阅界面
        query: {
          dataObj: subscribeType //参数对象
        }
      });
      //window.location.reload(); //刷新页面
      this.$emit("goSubscription", subscribeType);
    },

    //点击我
    memeListShow: function() {
      var that = this;
      if (that.userMsgStyle == "userMsgActive") {
        that.userMsgStyle = "";
        that.meListStyle = "";
      } else {
        that.userMsgStyle = "userMsgActive";
        that.meListStyle = "meListAcitve";
      }
    },

    //点击VIP会员
    isVipMember:async function() {
      var that = this;

      that.requestApi({
        method: "get",
        url: "/api/member/getMember",
        then(data) {
           if (data.data) {
             that.$router.push({
               path: "/vipFunction", //跳转的路由
               query: "" //参数对象
             });
           }else{
             // that.getMerberStatus({
             //    successFn: function() {
             //      that.$router.push({
             //        path: "/vipFunction", //跳转的路由
             //        query: "" //参数对象
             //      });
             //    }
             //  });
              that.$refs.vipBuyWindowPart.isMemberVip();
              that.$refs.vipBuyWindowPart.openVipTypeSelect();
           }
        }
      })

      // if (that.isMemberVipStatus == true) {
        // that.$router.push({
        //   path: "/vipFunction", //跳转的路由
        //   query: "" //参数对象
        // });
      // } else {
        // that.isPcVipTips = "该功能只对vip会员开放";
        // that.getMerberStatus({
        //   successFn: function() {
        //     that.$router.push({
        //       path: "/vipFunction", //跳转的路由
        //       query: "" //参数对象
        //     });
        //   }
        // });
       // await that.$refs.vipBuyWindowPart.isMemberVip();
       // await that.$refs.vipBuyWindowPart.openVipTypeSelect();
      // }
    },

    //判断用户是否登录
    getUserInfo() {
      let that = this;
      that.requestApi({
        method: "get",
        url: "/api/user/userInfo",
        loginStatus(res, status) {
          that.isLogin = true; //二维码登录的状态
        },
        then(data) {
          if (data.data != null) {
            that.isBindPhone();
          }
        }
      });
    },

     // 点击登录按钮
    login() {
      var that = this;
      var ewmLogin = that.$refs.ewmLogin;
      if (ewmLogin != null) {
        ewmLogin.showLogin();
      }
    },

    //获取会员的状态:返回状态,0:非会员,1:高级会员,2:待审核会员,3:审核失败,4:待上传支付凭证,10:专业会员
    // getMerberStatus: function({ successFn, tenderDetail }) {
    //   var that = this;
    //   if (tenderDetail != null || tenderDetail != undefined) {
    //     that.tenderDetail = tenderDetail;
    //   } else {
    //     that.tenderDetail = false;
    //   }
    //   console.log("header:" + that.tenderDetail);
    //   that.getUserInfo();
    //   that.requestApi({
    //     method: "get",
    //     url: "/api/member/getMerberStatus",
    //     then(data) {
    //       that.merberStatus = data.data.status;
    //       if (data.data.status == 0) {
    //         if (that.tenderDetail == false) {
    //           //非会员
    //           that.$message({
    //             showClose: true,
    //             message: "该功能只对专业会员开放",
    //             type: "error"
    //           });
    //         }
    //         if (that.$refs.vipBuyWindowPart != null) {
    //           that.$refs.vipBuyWindowPart.openVipTypeSelect();
    //         }
    //         return;
    //       } else if (data.data.status == 1) {
    //         //高级会员
    //         if (that.tenderDetail == false) {
    //           //非会员
    //           that.$message({
    //             showClose: true,
    //             message: "该功能只对专业会员开放",
    //             type: "error"
    //           });
    //         }
    //         if (that.$refs.vipBuyWindowPart != null) {
    //           that.$refs.vipBuyWindowPart.openVipRenewalFee(true);
    //         }
    //         return;
    //       } else if (data.data.status == 2) {
    //         that.$refs.vipBuyWindowPart.closeCompanyAnalyzeBg(); //关闭企业分析背景图
    //         that.$refs.vipBuyWindowPart.closeTenderAnalyzeBg(); //关闭标讯分析背景图
    //         //待审核会员
    //         if (that.tenderDetail == false) {
    //           //非会员
    //           that.$message({
    //             showClose: true,
    //             message: "该功能只对专业会员开放",
    //             type: "error"
    //           });
    //         }
    //         //跳转到我的订单列表
    //         that.$router.push({
    //           path: "/myOrder" //跳转的路由
    //         });
    //         return;
    //       } else if (data.data.status == 3) {
    //         that.$refs.vipBuyWindowPart.closeCompanyAnalyzeBg(); //关闭企业分析背景图
    //         that.$refs.vipBuyWindowPart.closeTenderAnalyzeBg(); //关闭标讯分析背景图
    //         //审核失败
    //         if (that.tenderDetail == false) {
    //           //非会员
    //           that.$message({
    //             showClose: true,
    //             message: "该功能只对专业会员开放",
    //             type: "error"
    //           });
    //         }
    //         //跳转到我的订单列表
    //         that.$router.push({
    //           path: "/myOrder" //跳转的路由
    //         });
    //         return;
    //       } else if (data.data.status == 4) {
    //         that.$refs.vipBuyWindowPart.closeCompanyAnalyzeBg(); //关闭企业分析背景图
    //         that.$refs.vipBuyWindowPart.closeTenderAnalyzeBg(); //关闭标讯分析背景图
    //         //待上传支付凭证
    //         if (that.tenderDetail == false) {
    //           //非会员
    //           that.$message({
    //             showClose: true,
    //             message: "该功能只对专业会员开放",
    //             type: "error"
    //           });
    //         }
    //         //跳转到我的订单列表
    //         that.$router.push({
    //           path: "/myOrder" //跳转的路由
    //         });
    //         return;
    //       } else if (data.data.status == 10) {
    //         that.$refs.vipBuyWindowPart.closeCompanyAnalyzeBg(); //关闭企业分析背景图
    //         that.$refs.vipBuyWindowPart.closeTenderAnalyzeBg(); //关闭标讯分析背景图
    //         //专业会员
    //         if (successFn != null) {
    //           successFn();
    //         }
    //       }
    //     }
    //   });
    //   that.$emit("getMerberStatus"); //getMerberStatus()方法公开出去，这样在组件外也可调用该方法
    // },

    //判断是否为会员（pcVipStatus）
    getMerberStatus: function({ successFn, tenderDetail }) {
      var that = this;
      if (tenderDetail != null || tenderDetail != undefined) {
        that.tenderDetail = tenderDetail;
      } else {
        that.tenderDetail = false;
      }
      console.log("header:" + that.tenderDetail);
      that.getUserInfo();
      that.requestApi({
        method: "get",
        url: "/api/member/isMember",
        then(data) {
          //0：非会员；2：移动端月会员
          if (data.data == 0 || data.data == 2) {
            that.pcVipStatus = false; //会员状态
            if (that.tenderDetail == false) {
              //非会员或移动端月会员
              that.$message({
                showClose: true,
                message: that.isPcVipTips,
                type: "error"
              });
            }
            if (that.$refs.vipBuyWindowPart != null) {
              that.$refs.vipBuyWindowPart.openVipTypeSelect();
            }
            return;
          } else {
            that.pcVipStatus = true; //会员状态
            that.$refs.vipBuyWindowPart.closeCompanyAnalyzeBg(); //关闭企业分析背景图
            that.$refs.vipBuyWindowPart.closeTenderAnalyzeBg(); //关闭标讯分析背景图
            //待审核会员
            if (successFn != null) {
              successFn();
            }
          }
        }
      });
      that.$emit("getMerberStatus"); //getMerberStatus()方法公开出去，这样在组件外也可调用该方法
    },

    //判断是否为pc端vip会员（不包含移动端月会员）
    isPcVip(isPcVipTips) {
      var that = this;
      console.log("isPcVipTips:", isPcVipTips);
      that.requestApi({
        method: "get",
        url: "/api/member/isMember",
        then(data) {
          //0：非会员；2：移动端月会员
          if (data.data == 0 || data.data == 2) {
            that.pcVipStatus = false;
            //非会员或移动端月会员
            that.$message({
              showClose: true,
              message:
                isPcVipTips == undefined ? that.isPcVipTips : isPcVipTips,
              type: "error"
            });
            if (that.$refs.vipBuyWindowPart != null) {
              that.$refs.vipBuyWindowPart.openVipTypeSelect();
            }
            return false;
          } else {
            that.pcVipStatus = true;
          }
        }
      });
      that.$emit("isPcVip", isPcVipTips);
    },

    //判断是否为vip会员（包含移动端月会员）
    isMemberVip(isPcVipTips) {
      var that = this;
      console.log("isPcVipTips:", isPcVipTips);
      that.requestApi({
        method: "get",
        url: "/api/member/isMember",
        then(data) {
          //0：非会员
          if (data.data == 0) {
            that.isMemberVipStatus = false;
            //非会员
            that.$message({
              showClose: true,
              message:
                isPcVipTips == undefined ? that.isPcVipTips : isPcVipTips,
              type: "error"
            });
            if (that.$refs.vipBuyWindowPart != null) {
              that.$refs.vipBuyWindowPart.openVipTypeSelect();
            }
            return false;
          } else {
            that.isMemberVipStatus = true;
          }
        }
      });
      that.$emit("isMemberVip", isPcVipTips);
    },

    //点击我的订单
    goOrder: function() {
      var that = this;
      that.$router.push({
        path: "/myOrder" //跳转的路由
      });
    },

    //用户登录成功，显示用户信息以及相关菜单
    getUserMsg() {
      let that = this;
      that.requestApi({
        method: "get",
        url: "/api/user/userInfo",
        then(data) {
          if (data.data != null) {
            that.loginBtnShow = false;
            that.meShow = true;
            that.bgShow = true;
            that.userAvatarLink = data.data.portrait;
            that.userName = data.data.name;
            that.userPhone = data.data.phone;
            that.requestApi({
              method: "get",
              url: "/api/member/isMember",
              then(data) {
                if (data.data != null) {
                  if (data.data == 0 || data.data == 2) {
                    //非pc端会员
                    that.pcVipStatus = false; //会员状态
                  } else {
                    that.pcVipStatus = true; //会员状态
                  }
                  if (data.data == 0) {
                    that.isMemberVipStatus = false; //会员
                  } else {
                    that.isMemberVipStatus = true; //非会员
                  }
                }
              }
            });
          } else {
            that.meShow = false;
            that.bgShow = false;
            that.loginBtnShow = true;
          }
        }
      });
      that.$emit("getUserMsg"); //将getUserMsg()方法公开出去，这样在组件外也可调用该方法
    },

    //退出登录
    exitLogin: function() {
      let that = this;
      that.requestApi({
        method: "get",
        url: "/api/login/exit",
        then(data) {
          if (data.data == true) {
            that.$message({
              message: "退出登录成功",
              type: "success"
            });

            setTimeout(() => {
              that.$router.push({
                path: "/index" //跳转的路由
              });
              window.location.reload(); //登录成功后刷新页面
            }, 2000);
          }
        }
      });
    },

    //点击修改密码按钮
    goFindPassword: function() {
      var that = this;
      that.$refs.phoneLoginPart.openFindPassWord();
    }
  },

  created() {
    var that = this;
    that.getUserMsg(); //判断用户是否登录
  },
  /**
   * 模板渲染成html后调用
   */
  mounted() {
    var that = this;
    that.showBate = getVersion() === "dev";
    this.$baidu();

    //是否弹出那个右边的广告
    const tempStorage = localStorage.getItem("popActivity.showRigth");
    if(!tempStorage){
      this.popActivity.showRigth = true;
    }else{
      if(tempStorage == base().formatDate(Date.now())){
        this.popActivity.showRigth = false;
      }else{
        this.popActivity.showRigth = true;
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header {
  position: fixed;
  width: 100%;
  height: 60px;
  z-index: 100;
}
.headerDiv {
  padding: 0 40px;
  height: 60px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.02);
  position: relative;
}
.header .header-logo {
  position: absolute;
  top: 0;
  left: 40px;
  cursor: pointer;
  line-height: 60px;
}
.header-logo span {
  display: inline-block;
  font-size: 18px;
  color: #2b5f80;
  margin-left: 5px;
}
.header-logo span em {
  font-weight: bold;
}
.header .header-nav {
  margin: 0 auto;
}
.header .el-menu {
  position: initial;
  display: flex;
  justify-content: center;
  align-items: center;
}
.header .el-menu.el-menu--horizontal {
  border: none;
}
.header-nav li,
.header-nav .el-menu--horizontal > .el-submenu .el-submenu__title,
.header-nav .el-submenu__title {
  display: inline-block;
  height: 60px;
  line-height: 58.5px;
  text-align: center;
  font-size: 16px;
  color: #949494;
  padding: 0 20px;
  font-weight: bold;
}
.header-nav .el-menu--horizontal > .el-menu-item.is-active,
.header-nav .el-menu--horizontal > .el-menu-item:hover {
  border-bottom: 3px solid #2b5f80;
  color: #2b5f80;
}
.header .header-me {
  position: absolute;
  top: 0;
  right: 40px;
  text-align: right;
}
.header #userMsg {
  position: relative;
  padding-right: 26px;
  padding-left: 42px;
  font-size: 14px;
  cursor: pointer;
  z-index: 9;
  background: #fff;
  height: 60px;
  text-align: center;
  padding-right: 30px;
}

.header #userMsg .meMsg {
  height: 60px;
  vertical-align: middle;
  display: table-cell;
}

.header .userAvatar img {
  position: absolute;
  top: 50%;
  margin-top: -16px;
  left: 0;
  width: 32px;
  height: 32px;
  border-radius: 50%;
}
.header #userMsg i img {
  position: absolute;
  top: 50%;
  margin-top: -3.5px;
  right: 11px;
  transition: all 300ms;
}
.header .header-me:hover #userMsg i img {
  transform: rotate(180deg);
}
.header .meList {
  min-width: 153px;
  position: absolute;
  right: 0;
  top: -300px;
  background: #fff;
  border: 1px solid #eee;
  transition: all 500ms;
  z-index: -1;
}
.header .header-me:hover .meList {
  top: 60px;
}
.header .meList a {
  display: block;
  width: 115px;
  height: 40px;
  line-height: 40px;
  color: #535353;
  font-size: 14px;
  border-bottom: 1px solid #eee;
  margin-left: 20px;
  text-indent: 29px;
  text-align: left;
}
.header .meList a:last-child {
  border-bottom: none;
}
.header .meList a.a01 {
  background: url(../header/img/meIco1.png) left center no-repeat;
}
.header .meList a.a02 {
  background: url(../header/img/meIco2.png) left center no-repeat;
}
.header .meList a.a03 {
  background: url(../header/img/meIco3.png) left center no-repeat;
}
.header .meList a.a04 {
  background: url(../header/img/meIco4.png) left center no-repeat;
}
.header .meList a.a05 {
  background: url(../header/img/meIco7.png) left center no-repeat;
}
.header .meList a.a06 {
  background: url(../header/img/meIco5.png) left center no-repeat;
}
.header .meList a.a07 {
  background: url(../header/img/meIco6.png) left center no-repeat;
}
.header .meList a.a08 {
  background: url(../header/img/meIco8.png) left center no-repeat;
}
.header .meList a.a09 {
  background: url(../header/img/meIco9.png) left center no-repeat;
}
.header-loginBtn {
  position: absolute;
  top: 15px;
  right: 40px;
  z-index: 10;
  background: linear-gradient(
    162deg,
    rgba(51, 107, 142, 1) 0%,
    rgba(25, 159, 175, 1) 100%
  );
  color: #fff;
  display: block;
  width: 80px;
  text-align: center;
  height: 30px;
  line-height: 30px;
  border-radius: 20px;
  font-size: 14px;
}
.bxfxImg{
  position: absolute;
      top: 0;
      right: -13px;
      height: 32px;
}
</style>



// WEBPACK FOOTER //
// src/components/header/header.vue